import { SelectItem } from "../../types/SelectItem";

export const selectLoanPurpose: SelectItem[] = [
  { label: "Purchase", value: "Purchase" },
  { label: "Refinance", value: "Refinance" },
];

export const selectLoanProduct: SelectItem[] = [
  { label: "FixNFlip", value: "FixNFlip" },
  { label: "BridgePlus", value: "BridgePlus" },
  { label: "New Construction", value: "New Construction" },
];

export const selectPropertyType: SelectItem[] = [
  { label: "SFR", value: "SFR" },
  { label: "2-4 Unit", value: "2-4 Unit" },
  { label: "Condo", value: "Condo" },
  { label: "5-9 Unit", value: "5-9 Unit" },
];

export const selectChannel: SelectItem[] = [
  { label: "Standard Retail", value: "Standard Retail" },
  { label: "Broker", value: "Broker" },
];

export const brokerRetailSelectChannel: SelectItem[] = [
  { label: "Standard Retail", value: "Standard Retail" },
  { label: "Broker", value: "Broker" },
  { label: "Broker Retail", value: "Broker Retail" },
];

export const thirdPartyRetailSelectChannel: SelectItem[] = [
  { label: "Standard Retail", value: "Standard Retail" },
  { label: "Broker", value: "Broker" },
  { label: "Broker Retail", value: "Broker Retail" },
  { label: "Wholesale", value: "Wholesale" },
  { label: "Third Party Originator", value: "Third Party Originator" },
];

export const adminSelectChannel: SelectItem[] = [
  { label: "Standard Retail", value: "Standard Retail" },
  { label: "Broker", value: "Broker" },
  { label: "Broker Retail", value: "Broker Retail" },
  { label: "Wholesale", value: "Wholesale" },
  { label: "Third Party Originator", value: "Third Party Originator" },
];

export const selectLoanTerm: SelectItem[] = [
  { label: "13", value: "13" },
  { label: "19", value: "19" },
  { label: "24", value: "24" },
];

export const selectFixAndFlipLoanTerm: SelectItem[] = [
  { label: "13", value: "13" },
  { label: "19", value: "19" },
];

export const selectGuaranty: SelectItem[] = [
  { label: "Full Recourse", value: "Full Recourse" },
  { label: "Non-Recourse", value: "Non-Recourse" },
];

export const selectDebtStatus: SelectItem[] = [
  { label: "Purchase", value: "Purchase" },
  { label: "Free & Clear", value: "Free & Clear" },
  { label: "Payoff Existing Mortgage", value: "Payoff Existing Mortgage" },
];

export const selectDeferredOrig: SelectItem[] = [
  { label: "0", value: 0 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
];

export const selectMonthsOfInterestReserves: SelectItem[] = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
  { label: "11", value: 11 },
  { label: "12", value: 12 },
];

export const selectStates: SelectItem[] = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District Of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];
